<template>
    <section class="section-tiles" :class="color">
        <LayoutContained :class="padding">
            <ContentHeading
                v-if="heading"
                :heading="heading"
                :headingColor="headingColor"
                :headingComponent="headingComponent"
                :marginBottom="content ? 'mb-3' : 'mb-0'"
                :textCentered="textCentered"
            ></ContentHeading>
            <ContentText
                v-if="content"
                :html="content"
                :contentColor="contentColor"
                :textCentered="textCentered"
            ></ContentText>
            <LayoutTiles
                v-if="tiles && tiles.length"
                :class="heading || content ? 'mt-7' : ''"
                :tileDividerColor="tileDividerColor"
            >
                <LayoutTile
                    v-for="(tile, index) in tiles"
                    :key="'section-tiles-tile-' + index"
                    :color="tile.active ? activeTileColor : tileColor"
                    :headingColor="tile.active ? 'text-white' : undefined"
                    :url="tile.url"
                    :route="tile.route"
                    :image="tile.image"
                    :imageLoading="tile.imageLoading"
                    :fetchPriority="tile.fetchPriority"
                    :heading="tile.heading"
                    :headingComponent="tile.headingComponent"
                    :excerpt="tile.excerpt"
                    :rounding="tileRounding"
                ></LayoutTile>
            </LayoutTiles>
            <slot name="custom"></slot>
        </LayoutContained>
    </section>
</template>

<script>
export default {
    name: 'SectionTiles',
    props: {
        tiles: {
            required: false,
            type: Array,
            default () {
                return [];
            },
        },
        padding: {
            required: false,
            default: 'py-12 sm:py-14',
            type: String,
        },
        color: {
            required: false,
            type: String,
            default: 'bg-white',
        },
        activeTileColor: {
            required: false,
            type: String,
            default: 'bg-amber-700 shadow shadow-zinc-300 hover:shadow-sm hover:shadow-zinc-400'
        },
        tileColor: {
            required: false,
            type: String,
            default: 'bg-zinc-50 shadow shadow-zinc-300 hover:shadow-sm hover:shadow-zinc-400',
        },
        tileDividerColor: {
            required: false,
            type: String,
            default: 'divide-white',
        },
        tileRounding: {
            required: false,
            type: String,
            default: 'rounded-md',
        },
        tileSpacing: {
            required: false,
            type: String,
            default: 'space-y-3',
        },
        content: {
            required: false,
            type: String,
            default: null,
        },
        contentColor: {
            required: false,
            type: String,
            default: 'text-gray-600',
        },
        heading: {
            required: false,
            type: String,
            default: null,
        },
        headingColor: {
            required: false,
            type: String,
            default: 'text-gray-900',
        },
        headingComponent: {
            required: false,
            type: String,
            default: 'h1',
        },
        textCentered: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
    },
};
</script>
